import type { Fill } from 'types'

export const getFormattedInventoryGroupName = (fill: Fill) => {
  const inventoryGroup = fill.dispensed.inventoryGroup
  // Don't show the default inventory group "Rx"
  if (!inventoryGroup || inventoryGroup.pioneerAlias === 'Rx') return ''
  return `(${inventoryGroup.pioneerAlias})`
}
